import '../Assets/css/Empresa.css';

export const Empresa = () => {
    return (
        <div className="company-profile" id='nosotros'>
            <div className="company-container">
                <div className="company-text">
                    <h1>Travel Pluss</h1>
                    <p>Travel Pluss, la línea de transporte privado de Grupo Pluss
                        Chile, revoluciona el mercado con traslados en bus
                        centrados en seguridad y confort. Diseñados para
                        eventos corporativos, celebraciones familiares y más,
                        nuestros servicios garantizan comodidad y eficiencia.
                        Priorizamos la seguridad con medidas como el Sensor de
                        fatiga y somnolencia, seguimiento GPS y el sistema de
                        anticolisión MobilEye. Con una flota equipada con la
                        última tecnología y personal altamente capacitado,
                        ofrecemos traslados seguros y sin complicaciones. Al
                        elegirnos, los clientes obtienen exclusividad y confort,
                        respaldados por la reputación de Grupo Pluss Chile como
                        líder en transporte.</p>

                </div>
            </div>
        </div>
    )
}